import { ReactNode } from 'react'
import CreationToolWelcomeButton from '../../../../types/welcome-button'

type Props = {
    children?: ReactNode
    className?: string
    button: CreationToolWelcomeButton
}

const CreationToolsWelcomeLinkButton = ({ children, className, button }: Props) => (
    <a href={CreationToolWelcomeButton.url(button)} className={className}>
        {children}
    </a>
)

export default CreationToolsWelcomeLinkButton
